"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _areaCodes = require("./areaCodes");

var _default = [{
  mask: '+850-191-###-####',
  test: /^850191(\d{0,7})/g,
  valid: /^850191(\d{7})$/,
  count: 6,
  code: '+850-191',
  country: 'KP',
  names: {
    ru: 'Северная Корея',
    en: 'North Korea'
  }
}, {
  mask: '+39-6-698-#####',
  test: /^396698(\d{0,5})/g,
  valid: /^396698(\d{5})$/,
  count: 6,
  code: '+39-6-698',
  country: 'VA',
  names: {
    ru: 'Ватикан',
    en: 'Vatican'
  }
}, {
  mask: '+975-17-###-###',
  test: /^97517(\d{0,6})/g,
  valid: /^97517(\d{6})$/,
  count: 5,
  code: '+975-17',
  country: 'BT',
  names: {
    ru: 'Бутан',
    en: 'Bhutan'
  }
}, {
  mask: '+856(20##)###-###',
  test: /^85620(\d{0,8})/g,
  valid: /^85620(\d{8})$/,
  count: 5,
  code: '+856(20)',
  country: 'LA',
  names: {
    ru: 'Лаос',
    en: 'Laos'
  }
}, {
  mask: '+218-21-###-####',
  test: /^21821(\d{0,7})/g,
  valid: /^21821(\d{7})$/,
  count: 5,
  code: '+218-21',
  country: 'LY',
  names: {
    ru: 'Ливия',
    en: 'Libya'
  }
}, {
  mask: '+670-77#-#####',
  test: /^67077(\d{0,6})/g,
  valid: /^67077(\d{6})$/,
  count: 5,
  code: '+670-77',
  country: 'TL',
  names: {
    ru: 'Восточный Тимор',
    en: 'East Timor'
  }
}, {
  mask: '+670-78#-#####',
  test: /^67078(\d{0,6})/g,
  valid: /^67078(\d{6})$/,
  count: 5,
  code: '+670-78',
  country: 'TL',
  names: {
    ru: 'Восточный Тимор',
    en: 'East Timor'
  }
}, {
  mask: '+688-90####',
  test: /^68890(\d{0,4})/g,
  valid: /^68890(\d{4})$/,
  count: 5,
  code: '+688-90',
  country: 'TV',
  names: {
    ru: 'Тувалу',
    en: 'Tuvalu'
  }
}, {
  mask: '+971-5#-###-####',
  test: /^9715(\d{0,8})/g,
  valid: /^9715(\d{8})$/,
  count: 4,
  code: '+971-5',
  country: 'AE',
  names: {
    ru: 'ОАЭ',
    en: 'United Arab Emirates'
  }
}, {
  mask: '+1(268)###-####',
  test: /^1268(\d{0,7})/g,
  valid: /^1268(\d{7})$/,
  count: 4,
  code: '+1(268)',
  country: 'AG',
  names: {
    ru: 'Антигуа',
    en: 'Antigua and Barbuda'
  }
}, {
  mask: '+1(264)###-####',
  test: /^1264(\d{0,7})/g,
  valid: /^1264(\d{7})$/,
  count: 4,
  code: '+1(264)',
  country: 'AI',
  names: {
    ru: 'Ангилья',
    en: 'Anguilla'
  }
}, {
  mask: '+1(684)###-####',
  test: /^1684(\d{0,7})/g,
  valid: /^1684(\d{7})$/,
  count: 4,
  code: '+1(684)',
  country: 'AS',
  names: {
    ru: 'Американское Самоа',
    en: 'American Samoa'
  }
}, {
  mask: '+1(246)###-####',
  test: /^1246(\d{0,7})/g,
  valid: /^1246(\d{7})$/,
  count: 4,
  code: '+1(246)',
  country: 'BB',
  names: {
    ru: 'Барбадос',
    en: 'Barbados'
  }
}, {
  mask: '+1(441)###-####',
  test: /^1441(\d{0,7})/g,
  valid: /^1441(\d{7})$/,
  count: 4,
  code: '+1(441)',
  country: 'BM',
  names: {
    ru: 'Бермудские острова',
    en: 'Bermuda'
  }
}, {
  mask: '+1(242)###-####',
  test: /^1242(\d{0,7})/g,
  valid: /^1242(\d{7})$/,
  count: 4,
  code: '+1(242)',
  country: 'BS',
  names: {
    ru: 'Багамы',
    en: 'Bahamas'
  }
}, {
  mask: '+1(767)###-####',
  test: /^1767(\d{0,7})/g,
  valid: /^1767(\d{7})$/,
  count: 4,
  code: '+1(767)',
  country: 'DM',
  names: {
    ru: 'Доминика',
    en: 'Dominica'
  }
}, {
  mask: '+1(809)###-####',
  test: /^1809(\d{0,7})/g,
  valid: /^1809(\d{7})$/,
  count: 4,
  code: '+1(809)',
  country: 'DO',
  names: {
    ru: 'Доминиканская республика',
    en: 'Dominican Republic'
  }
}, {
  mask: '+1(829)###-####',
  test: /^1829(\d{0,7})/g,
  valid: /^1829(\d{7})$/,
  count: 4,
  code: '+1(829)',
  country: 'DO',
  names: {
    ru: 'Доминиканская республика',
    en: 'Dominican Republic'
  }
}, {
  mask: '+1(849)###-####',
  test: /^1849(\d{0,7})/g,
  valid: /^1849(\d{7})$/,
  count: 4,
  code: '+1(849)',
  country: 'DO',
  names: {
    ru: 'Доминиканская республика',
    en: 'Dominican Republic'
  }
}, {
  mask: '+1(473)###-####',
  test: /^1473(\d{0,7})/g,
  valid: /^1473(\d{7})$/,
  count: 4,
  code: '+1(473)',
  country: 'GD',
  names: {
    ru: 'Гренада',
    en: 'Grenada'
  }
}, {
  mask: '+1(671)###-####',
  test: /^1671(\d{0,7})/g,
  valid: /^1671(\d{7})$/,
  count: 4,
  code: '+1(671)',
  country: 'GU',
  names: {
    ru: 'Гуам',
    en: 'Guam'
  }
}, {
  mask: '+972-5#-###-####',
  test: /^9725(\d{0,8})/g,
  valid: /^9725(\d{8})$/,
  count: 4,
  code: '+972-5',
  country: 'IL',
  names: {
    ru: 'Израиль',
    en: 'Israel'
  }
}, {
  mask: '+1(876)###-####',
  test: /^1876(\d{0,7})/g,
  valid: /^1876(\d{7})$/,
  count: 4,
  code: '+1(876)',
  country: 'JM',
  names: {
    ru: 'Ямайка',
    en: 'Jamaica'
  }
}, {
  mask: '+1(869)###-####',
  test: /^1869(\d{0,7})/g,
  valid: /^1869(\d{7})$/,
  count: 4,
  code: '+1(869)',
  country: 'KN',
  names: {
    ru: 'Сент Киттс и Невис',
    en: 'Saint Kitts and Nevis'
  }
}, {
  mask: '+1(345)###-####',
  test: /^1345(\d{0,7})/g,
  valid: /^1345(\d{7})$/,
  count: 4,
  code: '+1(345)',
  country: 'KY',
  names: {
    ru: 'Каймановы острова',
    en: 'Cayman Islands'
  }
}, {
  mask: '+1(758)###-####',
  test: /^1758(\d{0,7})/g,
  valid: /^1758(\d{7})$/,
  count: 4,
  code: '+1(758)',
  country: 'LC',
  names: {
    ru: 'Сент-Люсия',
    en: 'St. Lucia'
  }
}, {
  mask: '+1(670)###-####',
  test: /^1670(\d{0,7})/g,
  valid: /^1670(\d{7})$/,
  count: 4,
  code: '+1(670)',
  country: 'MP',
  names: {
    ru: 'Северные Марианские Острова',
    en: 'Northern Mariana Islands'
  }
}, {
  mask: '+1(664)###-####',
  test: /^1664(\d{0,7})/g,
  valid: /^1664(\d{7})$/,
  count: 4,
  code: '+1(664)',
  country: 'MS',
  names: {
    ru: 'Монтсеррат',
    en: 'Montserrat'
  }
}, {
  mask: '+265-1-###-###',
  test: /^2651(\d{0,6})/g,
  valid: /^2651(\d{6})$/,
  count: 4,
  code: '+265-1',
  country: 'MW',
  names: {
    ru: 'Малави',
    en: 'Malawi'
  }
}, {
  mask: '+672-3##-###',
  test: /^6723(\d{0,5})/g,
  valid: /^6723(\d{5})$/,
  count: 4,
  code: '+672-3',
  country: 'NF',
  names: {
    ru: 'Остров Норфолк',
    en: 'Norfolk Island'
  }
}, {
  mask: '+966-5-####-####',
  test: /^9665(\d{0,8})/g,
  valid: /^9665(\d{8})$/,
  count: 4,
  code: '+966-5',
  country: 'SA',
  names: {
    ru: 'Саудовская Аравия',
    en: 'Saudi Arabia'
  }
}, {
  mask: '+1(721)###-####',
  test: /^1721(\d{0,7})/g,
  valid: /^1721(\d{7})$/,
  count: 4,
  code: '+1(721)',
  country: 'SX',
  names: {
    ru: 'Синт Мартен',
    en: 'St. Maarten'
  }
}, {
  mask: '+1(649)###-####',
  test: /^1649(\d{0,7})/g,
  valid: /^1649(\d{7})$/,
  count: 4,
  code: '+1(649)',
  country: 'TC',
  names: {
    ru: 'Теркс и Кайкос',
    en: 'Turks & Caicos'
  }
}, {
  mask: '+1(868)###-####',
  test: /^1868(\d{0,7})/g,
  valid: /^1868(\d{7})$/,
  count: 4,
  code: '+1(868)',
  country: 'TT',
  names: {
    ru: 'Тринидад и Тобаго',
    en: 'Trinidad & Tobago'
  }
}, {
  mask: '+688-2####',
  test: /^6882(\d{0,4})/g,
  valid: /^6882(\d{4})$/,
  count: 4,
  code: '+688-2',
  country: 'TV',
  names: {
    ru: 'Тувалу',
    en: 'Tuvalu'
  }
}, {
  mask: '+1(284)###-####',
  test: /^1284(\d{0,7})/g,
  valid: /^1284(\d{7})$/,
  count: 4,
  code: '+1(284)',
  country: 'VG',
  names: {
    ru: 'Британские Виргинские острова',
    en: 'British Virgin Islands'
  }
}, {
  mask: '+1(340)###-####',
  test: /^1340(\d{0,7})/g,
  valid: /^1340(\d{7})$/,
  count: 4,
  code: '+1(340)',
  country: 'VI',
  names: {
    ru: 'Виргинские острова (США)',
    en: 'Virgin Islands (USA)'
  }
}, {
  mask: '+376-###-###',
  test: /^376(\d{0,6})/g,
  valid: /^376(\d{6})$/,
  count: 3,
  code: '+376',
  country: 'AD',
  names: {
    ru: 'Андорра',
    en: 'Andorra'
  }
}, {
  mask: '+971-#-###-####',
  test: /^971(\d{0,8})/g,
  valid: /^971(\d{8})$/,
  count: 3,
  code: '+971',
  country: 'AE',
  names: {
    ru: 'Объединенные Арабские Эмираты',
    en: 'United Arab Emirates'
  }
}, {
  mask: '+355(###)###-###',
  test: /^355(\d{0,9})/g,
  valid: /^355(\d{9})$/,
  count: 3,
  code: '+355',
  country: 'AL',
  names: {
    ru: 'Албания',
    en: 'Albania'
  }
}, {
  mask: '+374-##-###-###',
  test: /^374(\d{0,8})/g,
  valid: /^374(\d{8})$/,
  count: 3,
  code: '+374',
  country: 'AM',
  names: {
    ru: 'Армения',
    en: 'Armenia'
  }
}, {
  areaCodes: _areaCodes.CaribbeanNetherlandsAreaCodes,
  mask: '+599-###-####',
  test: /^599(\d{0,7})/g,
  valid: /^599(\d{7})$/,
  count: 3,
  code: '+599',
  country: 'BQ',
  names: {
    ru: 'Карибские Нидерланды',
    en: 'Caribbean Netherlands'
  }
}, // TODO: Данная автономия в составе Королевства Нидерландов была
// расформирована 10 октября 2010 года, необходимо убрать её в будущем
{
  mask: '+599-###-####',
  test: /^599(\d{0,7})/g,
  valid: /^599(\d{7})$/,
  count: 3,
  code: '+599',
  country: 'AN',
  names: {
    ru: 'Нидерландские Антилы',
    en: 'Netherlands Antilles'
  }
}, {
  mask: '+244(###)###-###',
  test: /^244(\d{0,9})/g,
  valid: /^244(\d{9})$/,
  count: 3,
  code: '+244',
  country: 'AO',
  names: {
    ru: 'Ангола',
    en: 'Angola'
  }
}, {
  mask: '+297-###-####',
  test: /^297(\d{0,7})/g,
  valid: /^297(\d{7})$/,
  count: 3,
  code: '+297',
  country: 'AW',
  names: {
    ru: 'Аруба',
    en: 'Aruba'
  }
}, {
  mask: '+994-##-###-##-##',
  test: /^994(\d{0,9})/g,
  valid: /^994(\d{9})$/,
  count: 3,
  code: '+994',
  country: 'AZ',
  names: {
    ru: 'Азербайджан',
    en: 'Azerbaijan'
  }
}, {
  mask: '+387-##-#####',
  test: /^387(\d{0,7})/g,
  valid: /^387(\d{7})$/,
  count: 3,
  code: '+387',
  country: 'BA',
  names: {
    ru: 'Босния и Герцеговина',
    en: 'Bosnia-Herzegovina'
  }
}, {
  mask: '+387-##-####',
  test: /^387(\d{0,6})/g,
  valid: /^387(\d{6})$/,
  count: 3,
  code: '+387',
  country: 'BA',
  names: {
    ru: 'Босния и Герцеговина',
    en: 'Bosnia-Herzegovina'
  }
}, {
  mask: '+880-##-###-###',
  test: /^880(\d{0,8})/g,
  valid: /^880(\d{8})$/,
  count: 3,
  code: '+880',
  country: 'BD',
  names: {
    ru: 'Бангладеш',
    en: 'Bangladesh'
  }
}, {
  mask: '+226-##-##-####',
  test: /^226(\d{0,8})/g,
  valid: /^226(\d{8})$/,
  count: 3,
  code: '+226',
  country: 'BF',
  names: {
    ru: 'Буркина-Фасо',
    en: 'Burkina Faso'
  }
}, {
  mask: '+359(###)###-###',
  test: /^359(\d{0,9})/g,
  valid: /^359(\d{9})$/,
  count: 3,
  code: '+359',
  country: 'BG',
  names: {
    ru: 'Болгария',
    en: 'Bulgaria'
  }
}, {
  mask: '+973-####-####',
  test: /^973(\d{0,8})/g,
  valid: /^973(\d{8})$/,
  count: 3,
  code: '+973',
  country: 'BH',
  names: {
    ru: 'Бахрейн',
    en: 'Bahrain'
  }
}, {
  mask: '+257-##-##-####',
  test: /^257(\d{0,8})/g,
  valid: /^257(\d{8})$/,
  count: 3,
  code: '+257',
  country: 'BI',
  names: {
    ru: 'Бурунди',
    en: 'Burundi'
  }
}, {
  mask: '+229-##-##-####',
  test: /^229(\d{0,8})/g,
  valid: /^229(\d{8})$/,
  count: 3,
  code: '+229',
  country: 'BJ',
  names: {
    ru: 'Бенин',
    en: 'Benin'
  }
}, {
  mask: '+673-###-####',
  test: /^673(\d{0,7})/g,
  valid: /^673(\d{7})$/,
  count: 3,
  code: '+673',
  country: 'BN',
  names: {
    ru: 'Бруней Даруссалам',
    en: 'Brunei Darussalam'
  }
}, {
  mask: '+591-#-###-####',
  test: /^591(\d{0,8})/g,
  valid: /^591(\d{8})$/,
  count: 3,
  code: '+591',
  country: 'BO',
  names: {
    ru: 'Боливия',
    en: 'Bolivia'
  }
}, {
  mask: '+975-#-###-###',
  test: /^975(\d{0,7})/g,
  valid: /^975(\d{7})$/,
  count: 3,
  code: '+975',
  country: 'BT',
  names: {
    ru: 'Бутан',
    en: 'Bhutan'
  }
}, {
  mask: '+267-##-###-###',
  test: /^267(\d{0,8})/g,
  valid: /^267(\d{8})$/,
  count: 3,
  code: '+267',
  country: 'BW',
  names: {
    ru: 'Ботсвана',
    en: 'Botswana'
  }
}, {
  mask: '+375(##)###-##-##',
  test: /^375(\d{0,9})/g,
  valid: /^375(\d{9})$/,
  count: 3,
  code: '+375',
  country: 'BY',
  names: {
    ru: 'Беларусь (Республика Беларусь)',
    en: 'Belarus'
  }
}, {
  mask: '+501-###-####',
  test: /^501(\d{0,7})/g,
  valid: /^501(\d{7})$/,
  count: 3,
  code: '+501',
  country: 'BZ',
  names: {
    ru: 'Белиз',
    en: 'Belize'
  }
}, {
  mask: '+243(###)###-###',
  test: /^243(\d{0,9})/g,
  valid: /^243(\d{9})$/,
  count: 3,
  code: '+243',
  country: 'CD',
  names: {
    ru: 'Демократическая республика Конго',
    en: 'Democratic Republic of Congo'
  }
}, {
  mask: '+236-##-##-####',
  test: /^236(\d{0,8})/g,
  valid: /^236(\d{8})$/,
  count: 3,
  code: '+236',
  country: 'CF',
  names: {
    ru: 'Центральноафриканская Республика',
    en: 'Central Africa Republic'
  }
}, {
  mask: '+242-##-###-####',
  test: /^242(\d{0,9})/g,
  valid: /^242(\d{9})$/,
  count: 3,
  code: '+242',
  country: 'CG',
  names: {
    ru: 'Конго',
    en: 'Congo'
  }
}, {
  mask: '+225-##-###-###',
  test: /^225(\d{0,8})/g,
  valid: /^225(\d{8})$/,
  count: 3,
  code: '+225',
  country: 'CI',
  names: {
    ru: 'Кот д’Ивуар',
    en: 'Ivory Coast'
  }
}, {
  mask: '+682-##-###',
  test: /^682(\d{0,5})/g,
  valid: /^682(\d{5})$/,
  count: 3,
  code: '+682',
  country: 'CK',
  names: {
    ru: 'Острова Кука',
    en: 'Cook Islands'
  }
}, {
  mask: '+237-####-####',
  test: /^237(\d{0,8})/g,
  valid: /^237(\d{8})$/,
  count: 3,
  code: '+237',
  country: 'CM',
  names: {
    ru: 'Камерун',
    en: 'Cameroon'
  }
}, {
  mask: '+506-####-####',
  test: /^506(\d{0,8})/g,
  valid: /^506(\d{8})$/,
  count: 3,
  code: '+506',
  country: 'CR',
  names: {
    ru: 'Коста Рика',
    en: 'Costa Rica'
  }
}, {
  mask: '+238(###)##-##',
  test: /^238(\d{0,7})/g,
  valid: /^238(\d{7})$/,
  count: 3,
  code: '+238',
  country: 'CV',
  names: {
    ru: 'Кабо-Верде',
    en: 'Cape Verde'
  }
}, {
  mask: '+599-9##-####',
  test: /^5999(\d{0,6})/g,
  valid: /^5999(\d{6})$/,
  count: 4,
  code: '+599-9',
  country: 'CW',
  names: {
    ru: 'Кюрасао',
    en: 'Curacao'
  }
}, {
  mask: '+357-##-###-###',
  test: /^357(\d{0,8})/g,
  valid: /^357(\d{8})$/,
  count: 3,
  code: '+357',
  country: 'CY',
  names: {
    ru: 'Кипр',
    en: 'Cyprus'
  }
}, {
  mask: '+420(###)###-###',
  test: /^420(\d{0,9})/g,
  valid: /^420(\d{9})$/,
  count: 3,
  code: '+420',
  country: 'CZ',
  names: {
    ru: 'Чешская Республика',
    en: 'Czech Republic'
  }
}, {
  mask: '+253-##-##-##-##',
  test: /^253(\d{0,8})/g,
  valid: /^253(\d{8})$/,
  count: 3,
  code: '+253',
  country: 'DJ',
  names: {
    ru: 'Джибути',
    en: 'Djibouti'
  }
}, {
  mask: '+213-##-###-####',
  test: /^213(\d{0,9})/g,
  valid: /^213(\d{9})$/,
  count: 3,
  code: '+213',
  country: 'DZ',
  names: {
    ru: 'Алжир',
    en: 'Algeria'
  }
}, {
  mask: '+593-##-###-####',
  test: /^593(\d{0,9})/g,
  valid: /^593(\d{9})$/,
  count: 3,
  code: '+593',
  country: 'EC',
  names: {
    ru: 'Эквадор',
    en: 'Ecuador'
  }
}, {
  mask: '+593-#-###-####',
  test: /^593(\d{0,8})/g,
  valid: /^593(\d{8})$/,
  count: 3,
  code: '+593',
  country: 'EC',
  names: {
    ru: 'Эквадор',
    en: 'Ecuador'
  }
}, {
  mask: '+372-####-####',
  test: /^372(\d{0,8})/g,
  valid: /^372(\d{8})$/,
  count: 3,
  code: '+372',
  country: 'EE',
  names: {
    ru: 'Эстония',
    en: 'Estonia'
  }
}, {
  mask: '+372-###-####',
  test: /^372(\d{0,7})/g,
  valid: /^372(\d{7})$/,
  count: 3,
  code: '+372',
  country: 'EE',
  names: {
    ru: 'Эстония',
    en: 'Estonia'
  }
}, {
  mask: '+291-#-###-###',
  test: /^291(\d{0,7})/g,
  valid: /^291(\d{7})$/,
  count: 3,
  code: '+291',
  country: 'ER',
  names: {
    ru: 'Эритрея',
    en: 'Eritrea'
  }
}, {
  mask: '+251-##-###-####',
  test: /^251(\d{0,9})/g,
  valid: /^251(\d{9})$/,
  count: 3,
  code: '+251',
  country: 'ET',
  names: {
    ru: 'Эфиопия',
    en: 'Ethiopia'
  }
}, {
  mask: '+358(###)###-##-##',
  test: /^358(\d{0,10})/g,
  valid: /^358(\d{10})$/,
  count: 3,
  code: '+358',
  country: 'FI',
  names: {
    ru: 'Финляндия',
    en: 'Finland'
  }
}, {
  mask: '+679-##-#####',
  test: /^679(\d{0,7})/g,
  valid: /^679(\d{7})$/,
  count: 3,
  code: '+679',
  country: 'FJ',
  names: {
    ru: 'Фиджи',
    en: 'Fiji'
  }
}, {
  mask: '+500-#####',
  test: /^500(\d{0,5})/g,
  valid: /^500(\d{5})$/,
  count: 3,
  code: '+500',
  country: 'FK',
  names: {
    ru: 'Фолклендские острова',
    en: 'Falkland Islands (Malvinas)'
  }
}, {
  mask: '+691-###-####',
  test: /^691(\d{0,7})/g,
  valid: /^691(\d{7})$/,
  count: 3,
  code: '+691',
  country: 'FM',
  names: {
    ru: 'Микронезия',
    en: 'Micronesia'
  }
}, {
  mask: '+298-###-###',
  test: /^298(\d{0,6})/g,
  valid: /^298(\d{6})$/,
  count: 3,
  code: '+298',
  country: 'FO',
  names: {
    ru: 'Фарерские острова',
    en: 'Faroe Islands'
  }
}, {
  mask: '+262-#####-####',
  test: /^262(\d{0,9})/g,
  valid: /^262(\d{9})$/,
  count: 3,
  code: '+262',
  country: 'FR',
  names: {
    ru: 'Франция',
    en: 'France'
  }
}, {
  mask: '+508-##-####',
  test: /^508(\d{0,6})/g,
  valid: /^508(\d{6})$/,
  count: 3,
  code: '+508',
  country: 'FR',
  names: {
    ru: 'Франция',
    en: 'France'
  }
}, {
  mask: '+590(###)###-###',
  test: /^590(\d{0,9})/g,
  valid: /^590(\d{9})$/,
  count: 3,
  code: '+590',
  country: 'FR',
  names: {
    ru: 'Франция',
    en: 'France'
  }
}, {
  mask: '+241-#-##-##-##',
  test: /^241(\d{0,7})/g,
  valid: /^241(\d{7})$/,
  count: 3,
  code: '+241',
  country: 'GA',
  names: {
    ru: 'Габон',
    en: 'Gabon'
  }
}, {
  mask: '+995(###)###-###',
  test: /^995(\d{0,9})/g,
  valid: /^995(\d{9})$/,
  count: 3,
  code: '+995',
  country: 'GE',
  names: {
    ru: 'Грузия',
    en: 'Georgia'
  }
}, {
  mask: '+594-#####-####',
  test: /^594(\d{0,9})/g,
  valid: /^594(\d{9})$/,
  count: 3,
  code: '+594',
  country: 'GF',
  names: {
    ru: 'Французская Гвиана',
    en: 'French Guiana'
  }
}, {
  mask: '+233(###)###-###',
  test: /^233(\d{0,9})/g,
  valid: /^233(\d{9})$/,
  count: 3,
  code: '+233',
  country: 'GH',
  names: {
    ru: 'Гана',
    en: 'Ghana'
  }
}, {
  mask: '+350-###-#####',
  test: /^350(\d{0,8})/g,
  valid: /^350(\d{8})$/,
  count: 3,
  code: '+350',
  country: 'GI',
  names: {
    ru: 'Гибралтар',
    en: 'Gibraltar'
  }
}, {
  mask: '+299-##-##-##',
  test: /^299(\d{0,6})/g,
  valid: /^299(\d{6})$/,
  count: 3,
  code: '+299',
  country: 'GL',
  names: {
    ru: 'Гренландия',
    en: 'Greenland'
  }
}, {
  mask: '+220(###)##-##',
  test: /^220(\d{0,7})/g,
  valid: /^220(\d{7})$/,
  count: 3,
  code: '+220',
  country: 'GM',
  names: {
    ru: 'Гамбия',
    en: 'Gambia'
  }
}, {
  mask: '+224-##-###-###',
  test: /^224(\d{0,8})/g,
  valid: /^224(\d{8})$/,
  count: 3,
  code: '+224',
  country: 'GN',
  names: {
    ru: 'Гвинея',
    en: 'Guinea'
  }
}, {
  mask: '+240-##-###-####',
  test: /^240(\d{0,9})/g,
  valid: /^240(\d{9})$/,
  count: 3,
  code: '+240',
  country: 'GQ',
  names: {
    ru: 'Экваториальная Гвинея',
    en: 'Equatorial Guinea'
  }
}, {
  mask: '+502-#-###-####',
  test: /^502(\d{0,8})/g,
  valid: /^502(\d{8})$/,
  count: 3,
  code: '+502',
  country: 'GT',
  names: {
    ru: 'Гватемала',
    en: 'Guatemala'
  }
}, {
  mask: '+245-#-######',
  test: /^245(\d{0,7})/g,
  valid: /^245(\d{7})$/,
  count: 3,
  code: '+245',
  country: 'GW',
  names: {
    ru: 'Гвинея-Бисау',
    en: 'Guinea-Bissau'
  }
}, {
  mask: '+592-###-####',
  test: /^592(\d{0,7})/g,
  valid: /^592(\d{7})$/,
  count: 3,
  code: '+592',
  country: 'GY',
  names: {
    ru: 'Гайана',
    en: 'Guyana'
  }
}, {
  mask: '+852-####-####',
  test: /^852(\d{0,8})/g,
  valid: /^852(\d{8})$/,
  count: 3,
  code: '+852',
  country: 'HK',
  names: {
    ru: 'Гонконг (Китай)',
    en: 'Hong Kong (China)'
  }
}, {
  mask: '+504-####-####',
  test: /^504(\d{0,8})/g,
  valid: /^504(\d{8})$/,
  count: 3,
  code: '+504',
  country: 'HN',
  names: {
    ru: 'Гондурас',
    en: 'Honduras'
  }
}, {
  mask: '+385-##-###-###',
  test: /^385(\d{0,8})/g,
  valid: /^385(\d{8})$/,
  count: 3,
  code: '+385',
  country: 'HR',
  names: {
    ru: 'Хорватия',
    en: 'Croatia'
  }
}, {
  mask: '+509-##-##-####',
  test: /^509(\d{0,8})/g,
  valid: /^509(\d{8})$/,
  count: 3,
  code: '+509',
  country: 'HT',
  names: {
    ru: 'Гаити',
    en: 'Haiti'
  }
}, {
  mask: '+62(8##)###-####',
  test: /^628(\d{0,9})/g,
  valid: /^628(\d{9})$/,
  count: 3,
  code: '+62(8)',
  country: 'ID',
  names: {
    ru: 'Индонезия',
    en: 'Indonesia'
  }
}, {
  mask: '+62(8##)###-###',
  test: /^628(\d{0,8})/g,
  valid: /^628(\d{8})$/,
  count: 3,
  code: '+62(8)',
  country: 'ID',
  names: {
    ru: 'Индонезия',
    en: 'Indonesia'
  }
}, {
  mask: '+62(8##)###-##-###',
  test: /^628(\d{0,10})/g,
  valid: /^628(\d{10})$/,
  count: 3,
  code: '+62(8)',
  country: 'ID',
  names: {
    ru: 'Индонезия',
    en: 'Indonesia'
  }
}, {
  mask: '+353(###)###-###',
  test: /^353(\d{0,9})/g,
  valid: /^353(\d{9})$/,
  count: 3,
  code: '+353',
  country: 'IE',
  names: {
    ru: 'Ирландия',
    en: 'Ireland'
  }
}, {
  mask: '+972-#-###-####',
  test: /^972(\d{0,8})/g,
  valid: /^972(\d{8})$/,
  count: 3,
  code: '+972',
  country: 'IL',
  names: {
    ru: 'Израиль',
    en: 'Israel'
  }
}, {
  mask: '+246-###-####',
  test: /^246(\d{0,7})/g,
  valid: /^246(\d{7})$/,
  count: 3,
  code: '+246',
  country: 'IO',
  names: {
    ru: 'Британская Территория в Индийском Океане',
    en: 'British Indian Ocean Territory'
  }
}, {
  mask: '+964(###)###-####',
  test: /^964(\d{0,10})/g,
  valid: /^964(\d{10})$/,
  count: 3,
  code: '+964',
  country: 'IQ',
  names: {
    ru: 'Ирак',
    en: 'Iraq'
  }
}, {
  mask: '+354-###-####',
  test: /^354(\d{0,7})/g,
  valid: /^354(\d{7})$/,
  count: 3,
  code: '+354',
  country: 'IS',
  names: {
    ru: 'Исландия',
    en: 'Iceland'
  }
}, {
  mask: '+962-#-####-####',
  test: /^962(\d{0,9})/g,
  valid: /^962(\d{9})$/,
  count: 3,
  code: '+962',
  country: 'JO',
  names: {
    ru: 'Иордания',
    en: 'Jordan'
  }
}, {
  mask: '+254-###-######',
  test: /^254(\d{0,9})/g,
  valid: /^254(\d{9})$/,
  count: 3,
  code: '+254',
  country: 'KE',
  names: {
    ru: 'Кения',
    en: 'Kenya'
  }
}, {
  mask: '+996(###)###-###',
  test: /^996(\d{0,9})/g,
  valid: /^996(\d{9})$/,
  count: 3,
  code: '+996',
  country: 'KG',
  names: {
    ru: 'Кыргызстан',
    en: 'Kyrgyzstan'
  }
}, {
  mask: '+855-##-###-###',
  test: /^855(\d{0,8})/g,
  valid: /^855(\d{8})$/,
  count: 3,
  code: '+855',
  country: 'KH',
  names: {
    ru: 'Камбоджа',
    en: 'Cambodia'
  }
}, {
  mask: '+686-##-###',
  test: /^686(\d{0,5})/g,
  valid: /^686(\d{5})$/,
  count: 3,
  code: '+686',
  country: 'KI',
  names: {
    ru: 'Кирибати',
    en: 'Kiribati'
  }
}, {
  mask: '+269-##-#####',
  test: /^269(\d{0,7})/g,
  valid: /^269(\d{7})$/,
  count: 3,
  code: '+269',
  country: 'KM',
  names: {
    ru: 'Коморские острова',
    en: 'Comoros'
  }
}, {
  mask: '+850-##-###-###',
  test: /^850(\d{0,8})/g,
  valid: /^850(\d{8})$/,
  count: 3,
  code: '+850',
  country: 'KP',
  names: {
    ru: 'Северная Корея',
    en: 'North Korea'
  }
}, {
  mask: '+850-###-####-###',
  test: /^850(\d{0,10})/g,
  valid: /^850(\d{10})$/,
  count: 3,
  code: '+850',
  country: 'KP',
  names: {
    ru: 'Северная Корея',
    en: 'North Korea'
  }
}, {
  mask: '+850-###-###',
  test: /^850(\d{0,6})/g,
  valid: /^850(\d{6})$/,
  count: 3,
  code: '+850',
  country: 'KP',
  names: {
    ru: 'Северная Корея',
    en: 'North Korea'
  }
}, {
  mask: '+850-####-#############',
  test: /^850(\d{0,17})/g,
  valid: /^850(\d{17})$/,
  count: 3,
  code: '+850',
  country: 'KP',
  names: {
    ru: 'Северная Корея',
    en: 'North Korea'
  }
}, {
  mask: '+965-####-####',
  test: /^965(\d{0,8})/g,
  valid: /^965(\d{8})$/,
  count: 3,
  code: '+965',
  country: 'KW',
  names: {
    ru: 'Кувейт',
    en: 'Kuwait'
  }
}, {
  mask: '+856-##-###-###',
  test: /^856(\d{0,8})/g,
  valid: /^856(\d{8})$/,
  count: 3,
  code: '+856',
  country: 'LA',
  names: {
    ru: 'Лаос',
    en: 'Laos'
  }
}, {
  mask: '+961-##-###-###',
  test: /^961(\d{0,8})/g,
  valid: /^961(\d{8})$/,
  count: 3,
  code: '+961',
  country: 'LB',
  names: {
    ru: 'Ливан',
    en: 'Lebanon'
  }
}, {
  mask: '+961-#-###-###',
  test: /^961(\d{0,7})/g,
  valid: /^961(\d{7})$/,
  count: 3,
  code: '+961',
  country: 'LB',
  names: {
    ru: 'Ливан',
    en: 'Lebanon'
  }
}, {
  mask: '+423(###)###-####',
  test: /^423(\d{0,10})/g,
  valid: /^423(\d{10})$/,
  count: 3,
  code: '+423',
  country: 'LI',
  names: {
    ru: 'Лихтенштейн',
    en: 'Liechtenstein'
  }
}, {
  mask: '+231-##-###-###',
  test: /^231(\d{0,8})/g,
  valid: /^231(\d{8})$/,
  count: 3,
  code: '+231',
  country: 'LR',
  names: {
    ru: 'Либерия',
    en: 'Liberia'
  }
}, {
  mask: '+266-#-###-####',
  test: /^266(\d{0,8})/g,
  valid: /^266(\d{8})$/,
  count: 3,
  code: '+266',
  country: 'LS',
  names: {
    ru: 'Лесото',
    en: 'Lesotho'
  }
}, {
  mask: '+370(###)##-###',
  test: /^370(\d{0,8})/g,
  valid: /^370(\d{8})$/,
  count: 3,
  code: '+370',
  country: 'LT',
  names: {
    ru: 'Литва',
    en: 'Lithuania'
  }
}, {
  mask: '+352(###)###-###',
  test: /^352(\d{0,9})/g,
  valid: /^352(\d{9})$/,
  count: 3,
  code: '+352',
  country: 'LU',
  names: {
    ru: 'Люксембург',
    en: 'Luxembourg'
  }
}, {
  mask: '+371-##-###-###',
  test: /^371(\d{0,8})/g,
  valid: /^371(\d{8})$/,
  count: 3,
  code: '+371',
  country: 'LV',
  names: {
    ru: 'Латвия',
    en: 'Latvia'
  }
}, {
  mask: '+218-##-###-###',
  test: /^218(\d{0,8})/g,
  valid: /^218(\d{8})$/,
  count: 3,
  code: '+218',
  country: 'LY',
  names: {
    ru: 'Ливия',
    en: 'Libya'
  }
}, {
  mask: '+212-##-####-###',
  test: /^212(\d{0,9})/g,
  valid: /^212(\d{9})$/,
  count: 3,
  code: '+212',
  country: 'MA',
  names: {
    ru: 'Марокко',
    en: 'Morocco'
  }
}, {
  mask: '+377(###)###-###',
  test: /^377(\d{0,9})/g,
  valid: /^377(\d{9})$/,
  count: 3,
  code: '+377',
  country: 'MC',
  names: {
    ru: 'Монако',
    en: 'Monaco'
  }
}, {
  mask: '+377-##-###-###',
  test: /^377(\d{0,8})/g,
  valid: /^377(\d{8})$/,
  count: 3,
  code: '+377',
  country: 'MC',
  names: {
    ru: 'Монако',
    en: 'Monaco'
  }
}, {
  mask: '+373-####-####',
  test: /^373(\d{0,8})/g,
  valid: /^373(\d{8})$/,
  count: 3,
  code: '+373',
  country: 'MD',
  names: {
    ru: 'Молдова',
    en: 'Moldova'
  }
}, {
  mask: '+382-##-###-###',
  test: /^382(\d{0,8})/g,
  valid: /^382(\d{8})$/,
  count: 3,
  code: '+382',
  country: 'ME',
  names: {
    ru: 'Черногория',
    en: 'Montenegro'
  }
}, {
  mask: '+261-##-##-#####',
  test: /^261(\d{0,9})/g,
  valid: /^261(\d{9})$/,
  count: 3,
  code: '+261',
  country: 'MG',
  names: {
    ru: 'Мадагаскар',
    en: 'Madagascar'
  }
}, {
  mask: '+692-###-####',
  test: /^692(\d{0,7})/g,
  valid: /^692(\d{7})$/,
  count: 3,
  code: '+692',
  country: 'MH',
  names: {
    ru: 'Маршалловы острова',
    en: 'Marshall Islands'
  }
}, {
  mask: '+389-##-###-###',
  test: /^389(\d{0,8})/g,
  valid: /^389(\d{8})$/,
  count: 3,
  code: '+389',
  country: 'MK',
  names: {
    ru: 'Македония',
    en: 'Macedonia'
  }
}, {
  mask: '+223-##-##-####',
  test: /^223(\d{0,8})/g,
  valid: /^223(\d{8})$/,
  count: 3,
  code: '+223',
  country: 'ML',
  names: {
    ru: 'Мали',
    en: 'Mali'
  }
}, {
  mask: '+976-##-##-####',
  test: /^976(\d{0,8})/g,
  valid: /^976(\d{8})$/,
  count: 3,
  code: '+976',
  country: 'MN',
  names: {
    ru: 'Монголия',
    en: 'Mongolia'
  }
}, {
  mask: '+853-####-####',
  test: /^853(\d{0,8})/g,
  valid: /^853(\d{8})$/,
  count: 3,
  code: '+853',
  country: 'MO',
  names: {
    ru: 'Макао',
    en: 'Macau (China)'
  }
}, {
  mask: '+596(###)##-##-##',
  test: /^596(\d{0,9})/g,
  valid: /^596(\d{9})$/,
  count: 3,
  code: '+596',
  country: 'MQ',
  names: {
    ru: 'Мартиника',
    en: 'Martinique'
  }
}, {
  mask: '+222-##-##-####',
  test: /^222(\d{0,8})/g,
  valid: /^222(\d{8})$/,
  count: 3,
  code: '+222',
  country: 'MR',
  names: {
    ru: 'Мавритания',
    en: 'Mauritania'
  }
}, {
  mask: '+356-####-####',
  test: /^356(\d{0,8})/g,
  valid: /^356(\d{8})$/,
  count: 3,
  code: '+356',
  country: 'MT',
  names: {
    ru: 'Мальта',
    en: 'Malta'
  }
}, {
  mask: '+230-###-####',
  test: /^230(\d{0,7})/g,
  valid: /^230(\d{7})$/,
  count: 3,
  code: '+230',
  country: 'MU',
  names: {
    ru: 'Маврикий',
    en: 'Mauritius'
  }
}, {
  mask: '+960-###-####',
  test: /^960(\d{0,7})/g,
  valid: /^960(\d{7})$/,
  count: 3,
  code: '+960',
  country: 'MV',
  names: {
    ru: 'Мальдивы',
    en: 'Maldive Island'
  }
}, {
  mask: '+265-#-####-####',
  test: /^265(\d{0,9})/g,
  valid: /^265(\d{9})$/,
  count: 3,
  code: '+265',
  country: 'MW',
  names: {
    ru: 'Малави',
    en: 'Malawi'
  }
}, {
  mask: '+258-##-###-###',
  test: /^258(\d{0,8})/g,
  valid: /^258(\d{8})$/,
  count: 3,
  code: '+258',
  country: 'MZ',
  names: {
    ru: 'Мозамбик',
    en: 'Mozambique'
  }
}, {
  mask: '+264-##-###-####',
  test: /^264(\d{0,9})/g,
  valid: /^264(\d{9})$/,
  count: 3,
  code: '+264',
  country: 'NA',
  names: {
    ru: 'Намибия',
    en: 'Namibia'
  }
}, {
  mask: '+687-##-####',
  test: /^687(\d{0,6})/g,
  valid: /^687(\d{6})$/,
  count: 3,
  code: '+687',
  country: 'NC',
  names: {
    ru: 'Новая Каледония',
    en: 'New Caledonia'
  }
}, {
  mask: '+227-##-##-####',
  test: /^227(\d{0,8})/g,
  valid: /^227(\d{8})$/,
  count: 3,
  code: '+227',
  country: 'NE',
  names: {
    ru: 'Нигер',
    en: 'Niger'
  }
}, {
  mask: '+234(###)###-####',
  test: /^234(\d{0,10})/g,
  valid: /^234(\d{10})$/,
  count: 3,
  code: '+234',
  country: 'NG',
  names: {
    ru: 'Нигерия',
    en: 'Nigeria'
  }
}, {
  mask: '+234-##-###-###',
  test: /^234(\d{0,8})/g,
  valid: /^234(\d{8})$/,
  count: 3,
  code: '+234',
  country: 'NG',
  names: {
    ru: 'Нигерия',
    en: 'Nigeria'
  }
}, {
  mask: '+234-##-###-##',
  test: /^234(\d{0,7})/g,
  valid: /^234(\d{7})$/,
  count: 3,
  code: '+234',
  country: 'NG',
  names: {
    ru: 'Нигерия',
    en: 'Nigeria'
  }
}, {
  mask: '+234(###)###-####',
  test: /^234(\d{0,10})/g,
  valid: /^234(\d{10})$/,
  count: 3,
  code: '+234',
  country: 'NG',
  names: {
    ru: 'Нигерия',
    en: 'Nigeria'
  }
}, {
  mask: '+505-####-####',
  test: /^505(\d{0,8})/g,
  valid: /^505(\d{8})$/,
  count: 3,
  code: '+505',
  country: 'NI',
  names: {
    ru: 'Никарагуа',
    en: 'Nicaragua'
  }
}, {
  mask: '+977-##-###-###',
  test: /^977(\d{0,8})/g,
  valid: /^977(\d{8})$/,
  count: 3,
  code: '+977',
  country: 'NP',
  names: {
    ru: 'Непал',
    en: 'Nepal'
  }
}, {
  mask: '+674-###-####',
  test: /^674(\d{0,7})/g,
  valid: /^674(\d{7})$/,
  count: 3,
  code: '+674',
  country: 'NR',
  names: {
    ru: 'Науру',
    en: 'Nauru'
  }
}, {
  mask: '+683-####',
  test: /^683(\d{0,4})/g,
  valid: /^683(\d{4})$/,
  count: 3,
  code: '+683',
  country: 'NU',
  names: {
    ru: 'Ниуэ',
    en: 'Niue'
  }
}, {
  mask: '+968-##-###-###',
  test: /^968(\d{0,8})/g,
  valid: /^968(\d{8})$/,
  count: 3,
  code: '+968',
  country: 'OM',
  names: {
    ru: 'Оман',
    en: 'Oman'
  }
}, {
  mask: '+507-###-####',
  test: /^507(\d{0,7})/g,
  valid: /^507(\d{7})$/,
  count: 3,
  code: '+507',
  country: 'PA',
  names: {
    ru: 'Панама',
    en: 'Panama'
  }
}, {
  mask: '+689-##-##-##',
  test: /^689(\d{0,6})/g,
  valid: /^689(\d{6})$/,
  count: 3,
  code: '+689',
  country: 'PF',
  names: {
    ru: 'Французская Полинезия',
    en: 'French Polynesia'
  }
}, {
  mask: '+675(###)##-###',
  test: /^675(\d{0,8})/g,
  valid: /^675(\d{8})$/,
  count: 3,
  code: '+675',
  country: 'PG',
  names: {
    ru: 'Папуа - Новая Гвинея',
    en: 'Papua New Guinea'
  }
}, {
  mask: '+970-##-###-####',
  test: /^970(\d{0,9})/g,
  valid: /^970(\d{9})$/,
  count: 3,
  code: '+970',
  country: 'PS',
  names: {
    ru: 'Палестинская Территория',
    en: 'State of Palestine'
  }
}, {
  mask: '+351-##-###-####',
  test: /^351(\d{0,9})/g,
  valid: /^351(\d{9})$/,
  count: 3,
  code: '+351',
  country: 'PT',
  names: {
    ru: 'Португалия',
    en: 'Portugal'
  }
}, {
  mask: '+680-###-####',
  test: /^680(\d{0,7})/g,
  valid: /^680(\d{7})$/,
  count: 3,
  code: '+680',
  country: 'PW',
  names: {
    ru: 'Палау',
    en: 'Palau'
  }
}, {
  mask: '+595(###)###-###',
  test: /^595(\d{0,9})/g,
  valid: /^595(\d{9})$/,
  count: 3,
  code: '+595',
  country: 'PY',
  names: {
    ru: 'Парагвай',
    en: 'Paraguay'
  }
}, {
  mask: '+974-####-####',
  test: /^974(\d{0,8})/g,
  valid: /^974(\d{8})$/,
  count: 3,
  code: '+974',
  country: 'QA',
  names: {
    ru: 'Катар',
    en: 'Qatar'
  }
}, {
  mask: '+262-#####-####',
  test: /^262(\d{0,9})/g,
  valid: /^262(\d{9})$/,
  count: 3,
  code: '+262',
  country: 'RE',
  names: {
    ru: 'Реюньон',
    en: 'Reunion'
  }
}, {
  mask: '+381-##-###-####',
  test: /^381(\d{0,9})/g,
  valid: /^381(\d{9})$/,
  count: 3,
  code: '+381',
  country: 'RS',
  names: {
    ru: 'Сербия',
    en: 'Serbia'
  }
}, {
  mask: '+250(###)###-###',
  test: /^250(\d{0,9})/g,
  valid: /^250(\d{9})$/,
  count: 3,
  code: '+250',
  country: 'RW',
  names: {
    ru: 'Руанда',
    en: 'Rwanda'
  }
}, {
  mask: '+966-#-###-####',
  test: /^966(\d{0,8})/g,
  valid: /^966(\d{8})$/,
  count: 3,
  code: '+966',
  country: 'SA',
  names: {
    ru: 'Саудовская Аравия',
    en: 'Saudi Arabia'
  }
}, {
  mask: '+677-###-####',
  test: /^677(\d{0,7})/g,
  valid: /^677(\d{7})$/,
  count: 3,
  code: '+677',
  country: 'SB',
  names: {
    ru: 'Соломоновы острова',
    en: 'Solomon Islands'
  }
}, {
  mask: '+677-#####',
  test: /^677(\d{0,5})/g,
  valid: /^677(\d{5})$/,
  count: 3,
  code: '+677',
  country: 'SB',
  names: {
    ru: 'Соломоновы острова',
    en: 'Solomon Islands'
  }
}, {
  mask: '+248-#-###-###',
  test: /^248(\d{0,7})/g,
  valid: /^248(\d{7})$/,
  count: 3,
  code: '+248',
  country: 'SC',
  names: {
    ru: 'Сейшельские острова',
    en: 'Seychelles'
  }
}, {
  mask: '+249-##-###-####',
  test: /^249(\d{0,9})/g,
  valid: /^249(\d{9})$/,
  count: 3,
  code: '+249',
  country: 'SD',
  names: {
    ru: 'Судан',
    en: 'Sudan'
  }
}, {
  mask: '+290-####',
  test: /^290(\d{0,4})/g,
  valid: /^290(\d{4})$/,
  count: 3,
  code: '+290',
  country: 'SH',
  names: {
    ru: 'Остров Святой Елены',
    en: 'St Helena'
  }
}, {
  mask: '+290-####',
  test: /^290(\d{0,4})/g,
  valid: /^290(\d{4})$/,
  count: 3,
  code: '+290',
  country: 'SH',
  names: {
    ru: 'Остров Святой Елены',
    en: 'St Helena'
  }
}, {
  mask: '+386-##-###-###',
  test: /^386(\d{0,8})/g,
  valid: /^386(\d{8})$/,
  count: 3,
  code: '+386',
  country: 'SI',
  names: {
    ru: 'Словения',
    en: 'Slovenia'
  }
}, {
  mask: '+421(###)###-###',
  test: /^421(\d{0,9})/g,
  valid: /^421(\d{9})$/,
  count: 3,
  code: '+421',
  country: 'SK',
  names: {
    ru: 'Словакия',
    en: 'Slovakia'
  }
}, {
  mask: '+232-##-######',
  test: /^232(\d{0,8})/g,
  valid: /^232(\d{8})$/,
  count: 3,
  code: '+232',
  country: 'SL',
  names: {
    ru: 'Сьерра-Леоне',
    en: 'Sierra Leone'
  }
}, {
  mask: '+378-####-######',
  test: /^378(\d{0,10})/g,
  valid: /^378(\d{10})$/,
  count: 3,
  code: '+378',
  country: 'SM',
  names: {
    ru: 'Сан-Марино',
    en: 'San Marino'
  }
}, {
  mask: '+221-##-###-####',
  test: /^221(\d{0,9})/g,
  valid: /^221(\d{9})$/,
  count: 3,
  code: '+221',
  country: 'SN',
  names: {
    ru: 'Сенегал',
    en: 'Senegal'
  }
}, {
  mask: '+252-##-###-###',
  test: /^252(\d{0,8})/g,
  valid: /^252(\d{8})$/,
  count: 3,
  code: '+252',
  country: 'SO',
  names: {
    ru: 'Сомали',
    en: 'Somalia'
  }
}, {
  mask: '+252-#-###-###',
  test: /^252(\d{0,7})/g,
  valid: /^252(\d{7})$/,
  count: 3,
  code: '+252',
  country: 'SO',
  names: {
    ru: 'Сомали',
    en: 'Somalia'
  }
}, {
  mask: '+252-#-###-###',
  test: /^252(\d{0,7})/g,
  valid: /^252(\d{7})$/,
  count: 3,
  code: '+252',
  country: 'SO',
  names: {
    ru: 'Сомали',
    en: 'Somalia'
  }
}, {
  mask: '+597-###-####',
  test: /^597(\d{0,7})/g,
  valid: /^597(\d{7})$/,
  count: 3,
  code: '+597',
  country: 'SR',
  names: {
    ru: 'Суринам',
    en: 'Suriname'
  }
}, {
  mask: '+597-###-###',
  test: /^597(\d{0,6})/g,
  valid: /^597(\d{6})$/,
  count: 3,
  code: '+597',
  country: 'SR',
  names: {
    ru: 'Суринам',
    en: 'Suriname'
  }
}, {
  mask: '+211-##-###-####',
  test: /^211(\d{0,9})/g,
  valid: /^211(\d{9})$/,
  count: 3,
  code: '+211',
  country: 'SS',
  names: {
    ru: 'Южный Судан',
    en: 'South Sudan'
  }
}, {
  mask: '+239-##-#####',
  test: /^239(\d{0,7})/g,
  valid: /^239(\d{7})$/,
  count: 3,
  code: '+239',
  country: 'ST',
  names: {
    ru: 'Сан-Томе и Принсипи',
    en: 'Sao Tome and Principe'
  }
}, {
  mask: '+503-##-##-####',
  test: /^503(\d{0,8})/g,
  valid: /^503(\d{8})$/,
  count: 3,
  code: '+503',
  country: 'SV',
  names: {
    ru: 'Эль Сальвадор',
    en: 'El Salvador'
  }
}, {
  mask: '+963-##-####-###',
  test: /^963(\d{0,9})/g,
  valid: /^963(\d{9})$/,
  count: 3,
  code: '+963',
  country: 'SY',
  names: {
    ru: 'Сирия',
    en: 'Syria'
  }
}, {
  mask: '+268-##-##-####',
  test: /^268(\d{0,8})/g,
  valid: /^268(\d{8})$/,
  count: 3,
  code: '+268',
  country: 'SZ',
  names: {
    ru: 'Свазиленд',
    en: 'Swaziland'
  }
}, {
  mask: '+235-##-##-##-##',
  test: /^235(\d{0,8})/g,
  valid: /^235(\d{8})$/,
  count: 3,
  code: '+235',
  country: 'TD',
  names: {
    ru: 'Чад',
    en: 'Chad'
  }
}, {
  mask: '+228-##-###-###',
  test: /^228(\d{0,8})/g,
  valid: /^228(\d{8})$/,
  count: 3,
  code: '+228',
  country: 'TG',
  names: {
    ru: 'Того',
    en: 'Togo'
  }
}, {
  mask: '+992-##-###-####',
  test: /^992(\d{0,9})/g,
  valid: /^992(\d{9})$/,
  count: 3,
  code: '+992',
  country: 'TJ',
  names: {
    ru: 'Таджикистан',
    en: 'Tadjikistan'
  }
}, {
  mask: '+690-####',
  test: /^690(\d{0,4})/g,
  valid: /^690(\d{4})$/,
  count: 3,
  code: '+690',
  country: 'TK',
  names: {
    ru: 'Токелау',
    en: 'Tokelau'
  }
}, {
  mask: '+670-###-####',
  test: /^670(\d{0,7})/g,
  valid: /^670(\d{7})$/,
  count: 3,
  code: '+670',
  country: 'TL',
  names: {
    ru: 'Восточный Тимор',
    en: 'East Timor'
  }
}, {
  mask: '+993-#-###-####',
  test: /^993(\d{0,8})/g,
  valid: /^993(\d{8})$/,
  count: 3,
  code: '+993',
  country: 'TM',
  names: {
    ru: 'Туркмения',
    en: 'Turkmenistan'
  }
}, {
  mask: '+216-##-###-###',
  test: /^216(\d{0,8})/g,
  valid: /^216(\d{8})$/,
  count: 3,
  code: '+216',
  country: 'TN',
  names: {
    ru: 'Тунис',
    en: 'Tunisia'
  }
}, {
  mask: '+676-#####',
  test: /^676(\d{0,5})/g,
  valid: /^676(\d{5})$/,
  count: 3,
  code: '+676',
  country: 'TO',
  names: {
    ru: 'Тонга',
    en: 'Tonga'
  }
}, {
  mask: '+886-#-####-####',
  test: /^886(\d{0,9})/g,
  valid: /^886(\d{9})$/,
  count: 3,
  code: '+886',
  country: 'TW',
  names: {
    ru: 'Тайвань (Китай)',
    en: 'Taiwan (China)'
  }
}, {
  mask: '+886-####-####',
  test: /^886(\d{0,8})/g,
  valid: /^886(\d{8})$/,
  count: 3,
  code: '+886',
  country: 'TW',
  names: {
    ru: 'Тайвань (Китай)',
    en: 'Taiwan (China)'
  }
}, {
  mask: '+255-##-###-####',
  test: /^255(\d{0,9})/g,
  valid: /^255(\d{9})$/,
  count: 3,
  code: '+255',
  country: 'TZ',
  names: {
    ru: 'Объединенная Республика Танзания',
    en: 'Tanzania'
  }
}, {
  mask: '+380(##)###-##-##',
  test: /^380(\d{0,9})/g,
  valid: /^380(\d{9})$/,
  count: 3,
  code: '+380',
  country: 'UA',
  names: {
    ru: 'Украина',
    en: 'Ukraine'
  }
}, {
  mask: '+256(###)###-###',
  test: /^256(\d{0,9})/g,
  valid: /^256(\d{9})$/,
  count: 3,
  code: '+256',
  country: 'UG',
  names: {
    ru: 'Уганда',
    en: 'Uganda'
  }
}, {
  mask: '+598-#-###-##-##',
  test: /^598(\d{0,8})/g,
  valid: /^598(\d{8})$/,
  count: 3,
  code: '+598',
  country: 'UY',
  names: {
    ru: 'Уругвай',
    en: 'Uruguay'
  }
}, {
  mask: '+998-##-###-####',
  test: /^998(\d{0,9})/g,
  valid: /^998(\d{9})$/,
  count: 3,
  code: '+998',
  country: 'UZ',
  names: {
    ru: 'Узбекистан',
    en: 'Uzbekistan'
  }
}, {
  mask: '+678-##-#####',
  test: /^678(\d{0,7})/g,
  valid: /^678(\d{7})$/,
  count: 3,
  code: '+678',
  country: 'VU',
  names: {
    ru: 'Вануату',
    en: 'Vanuatu'
  }
}, {
  mask: '+678-#####',
  test: /^678(\d{0,5})/g,
  valid: /^678(\d{5})$/,
  count: 3,
  code: '+678',
  country: 'VU',
  names: {
    ru: 'Вануату',
    en: 'Vanuatu'
  }
}, {
  mask: '+685-##-####',
  test: /^685(\d{0,6})/g,
  valid: /^685(\d{6})$/,
  count: 3,
  code: '+685',
  country: 'WS',
  names: {
    ru: 'Самоа',
    en: 'Samoa'
  }
}, {
  mask: '+967-###-###-###',
  test: /^967(\d{0,9})/g,
  valid: /^967(\d{9})$/,
  count: 3,
  code: '+967',
  country: 'YE',
  names: {
    ru: 'Йеменская Республика',
    en: 'Yemen Republic'
  }
}, {
  mask: '+967-#-###-###',
  test: /^967(\d{0,7})/g,
  valid: /^967(\d{7})$/,
  count: 3,
  code: '+967',
  country: 'YE',
  names: {
    ru: 'Йеменская Республика',
    en: 'Yemen Republic'
  }
}, {
  mask: '+967-##-###-###',
  test: /^967(\d{0,8})/g,
  valid: /^967(\d{8})$/,
  count: 3,
  code: '+967',
  country: 'YE',
  names: {
    ru: 'Йеменская Республика',
    en: 'Yemen Republic'
  }
}, {
  mask: '+260-##-###-####',
  test: /^260(\d{0,9})/g,
  valid: /^260(\d{9})$/,
  count: 3,
  code: '+260',
  country: 'ZM',
  names: {
    ru: 'Замбия',
    en: 'Zambia'
  }
}, {
  mask: '+263-#-######',
  test: /^263(\d{0,7})/g,
  valid: /^263(\d{7})$/,
  count: 3,
  code: '+263',
  country: 'ZW',
  names: {
    ru: 'Зимбабве',
    en: 'Zimbabwe'
  }
}, {
  mask: '+93-##-###-####',
  test: /^93(\d{0,9})/g,
  valid: /^93(\d{9})$/,
  count: 2,
  code: '+93',
  country: 'AF',
  names: {
    ru: 'Афганистан',
    en: 'Afghanistan'
  }
}, {
  mask: '+54(###)###-####',
  test: /^54(\d{0,10})/g,
  valid: /^54(\d{10})$/,
  count: 2,
  code: '+54',
  country: 'AR',
  names: {
    ru: 'Аргентина',
    en: 'Argentina'
  }
}, {
  mask: '+43(###)###-#####',
  test: /^43(\d{0,11})/g,
  valid: /^43(\d{10,11})$/,
  count: 2,
  code: '+43',
  country: 'AT',
  names: {
    ru: 'Австрия',
    en: 'Austria'
  }
}, {
  mask: '+61-#-####-####',
  test: /^61(\d{0,9})/g,
  valid: /^61(\d{9})$/,
  count: 2,
  code: '+61',
  country: 'AU',
  names: {
    ru: 'Австралия',
    en: 'Australia'
  }
}, {
  mask: '+32(###)###-###',
  test: /^32(\d{0,9})/g,
  valid: /^32(\d{9})$/,
  count: 2,
  code: '+32',
  country: 'BE',
  names: {
    ru: 'Бельгия',
    en: 'Belgium'
  }
}, {
  mask: '+55(##)####-####',
  test: /^55(\d{0,10})/g,
  valid: /^55(\d{10})$/,
  count: 2,
  code: '+55',
  country: 'BR',
  names: {
    ru: 'Бразилия',
    en: 'Brazil'
  }
}, {
  mask: '+41-##-###-####',
  test: /^41(\d{0,9})/g,
  valid: /^41(\d{9})$/,
  count: 2,
  code: '+41',
  country: 'CH',
  names: {
    ru: 'Швейцария',
    en: 'Switzerland'
  }
}, {
  mask: '+56-#-####-####',
  test: /^56(\d{0,9})/g,
  valid: /^56(\d{9})$/,
  count: 2,
  code: '+56',
  country: 'CL',
  names: {
    ru: 'Чили',
    en: 'Chile'
  }
}, {
  mask: '+86(###)####-####',
  test: /^86(\d{0,11})/g,
  valid: /^86(\d{11})$/,
  count: 2,
  code: '+86',
  country: 'CN',
  names: {
    ru: 'Китай',
    en: 'China'
  }
}, {
  mask: '+86(###)####-###',
  test: /^86(\d{0,10})/g,
  valid: /^86(\d{10})$/,
  count: 2,
  code: '+86',
  country: 'CN',
  names: {
    ru: 'Китай',
    en: 'China'
  }
}, {
  mask: '+86-##-#####-#####',
  test: /^86(\d{0,12})/g,
  valid: /^86(\d{12})$/,
  count: 2,
  code: '+86',
  country: 'CN',
  names: {
    ru: 'Китай',
    en: 'China'
  }
}, {
  mask: '+57(###)###-####',
  test: /^57(\d{0,10})/g,
  valid: /^57(\d{10})$/,
  count: 2,
  code: '+57',
  country: 'CO',
  names: {
    ru: 'Колумбия',
    en: 'Colombia'
  }
}, {
  mask: '+53-#-###-####',
  test: /^53(\d{0,8})/g,
  valid: /^53(\d{8})$/,
  count: 2,
  code: '+53',
  country: 'CU',
  names: {
    ru: 'Куба',
    en: 'Cuba'
  }
}, {
  mask: '+49(####)###-####',
  test: /^49(\d{0,11})/g,
  valid: /^49(\d{11})$/,
  count: 2,
  code: '+49',
  country: 'DE',
  names: {
    ru: 'Германия',
    en: 'Germany'
  }
}, {
  mask: '+49(###)###-####',
  test: /^49(\d{0,10})/g,
  valid: /^49(\d{10})$/,
  count: 2,
  code: '+49',
  country: 'DE',
  names: {
    ru: 'Германия',
    en: 'Germany'
  }
}, {
  mask: '+49(###)##-####',
  test: /^49(\d{0,9})/g,
  valid: /^49(\d{9})$/,
  count: 2,
  code: '+49',
  country: 'DE',
  names: {
    ru: 'Германия',
    en: 'Germany'
  }
}, {
  mask: '+49(###)##-###',
  test: /^49(\d{0,8})/g,
  valid: /^49(\d{8})$/,
  count: 2,
  code: '+49',
  country: 'DE',
  names: {
    ru: 'Германия',
    en: 'Germany'
  }
}, {
  mask: '+49(###)##-##',
  test: /^49(\d{0,7})/g,
  valid: /^49(\d{7})$/,
  count: 2,
  code: '+49',
  country: 'DE',
  names: {
    ru: 'Германия',
    en: 'Germany'
  }
}, {
  mask: '+49-###-###',
  test: /^49(\d{0,6})/g,
  valid: /^49(\d{6})$/,
  count: 2,
  code: '+49',
  country: 'DE',
  names: {
    ru: 'Германия',
    en: 'Germany'
  }
}, {
  mask: '+45-##-##-##-##',
  test: /^45(\d{0,8})/g,
  valid: /^45(\d{8})$/,
  count: 2,
  code: '+45',
  country: 'DK',
  names: {
    ru: 'Дания',
    en: 'Denmark'
  }
}, {
  mask: '+20(###)###-####',
  test: /^20(\d{0,10})/g,
  valid: /^20(\d{10})$/,
  count: 2,
  code: '+20',
  country: 'EG',
  names: {
    ru: 'Египет',
    en: 'Egypt'
  }
}, {
  mask: '+34(###)###-###',
  test: /^34(\d{0,9})/g,
  valid: /^34(\d{9})$/,
  count: 2,
  code: '+34',
  country: 'ES',
  names: {
    ru: 'Испания',
    en: 'Spain'
  }
}, {
  mask: '+33(###)###-###',
  test: /^33(\d{0,9})/g,
  valid: /^33(\d{9})$/,
  count: 2,
  code: '+33',
  country: 'FR',
  names: {
    ru: 'Франция',
    en: 'France'
  }
}, {
  mask: '+30(###)###-####',
  test: /^30(\d{0,10})/g,
  valid: /^30(\d{10})$/,
  count: 2,
  code: '+30',
  country: 'GR',
  names: {
    ru: 'Греция',
    en: 'Greece'
  }
}, {
  mask: '+36(###)###-###',
  test: /^36(\d{0,9})/g,
  valid: /^36(\d{9})$/,
  count: 2,
  code: '+36',
  country: 'HU',
  names: {
    ru: 'Венгрия',
    en: 'Hungary'
  }
}, {
  mask: '+62-##-###-##',
  test: /^62(\d{0,7})/g,
  valid: /^62(\d{7})$/,
  count: 2,
  code: '+62',
  country: 'ID',
  names: {
    ru: 'Индонезия',
    en: 'Indonesia'
  }
}, {
  mask: '+62-##-###-###',
  test: /^62(\d{0,8})/g,
  valid: /^62(\d{8})$/,
  count: 2,
  code: '+62',
  country: 'ID',
  names: {
    ru: 'Индонезия',
    en: 'Indonesia'
  }
}, {
  mask: '+62-##-###-####',
  test: /^62(\d{0,9})/g,
  valid: /^62(\d{9})$/,
  count: 2,
  code: '+62',
  country: 'ID',
  names: {
    ru: 'Индонезия',
    en: 'Indonesia'
  }
}, {
  mask: '+91(####)###-###',
  test: /^91(\d{0,10})/g,
  valid: /^91(\d{10})$/,
  count: 2,
  code: '+91',
  country: 'IN',
  names: {
    ru: 'Индия',
    en: 'India'
  }
}, {
  mask: '+98(###)###-####',
  test: /^98(\d{0,10})/g,
  valid: /^98(\d{10})$/,
  count: 2,
  code: '+98',
  country: 'IR',
  names: {
    ru: 'Иран',
    en: 'Iran'
  }
}, {
  mask: '+39(###)####-###',
  test: /^39(\d{0,10})/g,
  valid: /^39(\d{10})$/,
  count: 2,
  code: '+39',
  country: 'IT',
  names: {
    ru: 'Италия',
    en: 'Italy'
  }
}, {
  mask: '+81-##-####-####',
  test: /^81(\d{0,10})/g,
  valid: /^81(\d{10})$/,
  count: 2,
  code: '+81',
  country: 'JP',
  names: {
    ru: 'Япония',
    en: 'Japan'
  }
}, {
  mask: '+81(###)###-###',
  test: /^81(\d{0,9})/g,
  valid: /^81(\d{9})$/,
  count: 2,
  code: '+81',
  country: 'JP',
  names: {
    ru: 'Япония',
    en: 'Japan'
  }
}, {
  mask: '+82-##-###-#####',
  test: /^82(\d{0,10})/g,
  valid: /^82(\d{9,10})$/,
  count: 2,
  code: '+82',
  country: 'KR',
  names: {
    ru: 'Южная Корея',
    en: 'South Korea'
  }
}, {
  mask: '+7(7##)###-##-##',
  pretest: true,
  precode: '+7',
  test: /^77(\d{0,9})/g,
  valid: /^77([0124567][0-8]\d{7})$/,
  count: 2,
  code: '+7(7',
  country: 'KZ',
  names: {
    ru: 'Казахстан',
    en: 'Kazakhstan'
  }
}, {
  mask: '+94-##-###-####',
  test: /^94(\d{0,9})/g,
  valid: /^94(\d{9})$/,
  count: 2,
  code: '+94',
  country: 'LK',
  names: {
    ru: 'Шри Ланка',
    en: 'Sri Lanka'
  }
}, {
  mask: '+95-##-###-###',
  test: /^95(\d{0,8})/g,
  valid: /^95(\d{8})$/,
  count: 2,
  code: '+95',
  country: 'MM',
  names: {
    ru: 'Мьянма',
    en: 'Myanmar'
  }
}, {
  mask: '+95-#-###-###',
  test: /^95(\d{0,7})/g,
  valid: /^95(\d{7})$/,
  count: 2,
  code: '+95',
  country: 'MM',
  names: {
    ru: 'Мьянма',
    en: 'Myanmar'
  }
}, {
  mask: '+95-###-###',
  test: /^95(\d{0,6})/g,
  valid: /^95(\d{6})$/,
  count: 2,
  code: '+95',
  country: 'MM',
  names: {
    ru: 'Мьянма',
    en: 'Myanmar'
  }
}, {
  mask: '+52(###)###-####',
  test: /^52(\d{0,10})/g,
  valid: /^52(\d{10})$/,
  count: 2,
  code: '+52',
  country: 'MX',
  names: {
    ru: 'Мексика',
    en: 'Mexico'
  }
}, {
  mask: '+52-##-##-####',
  test: /^52(\d{0,8})/g,
  valid: /^52(\d{8})$/,
  count: 2,
  code: '+52',
  country: 'MX',
  names: {
    ru: 'Мексика',
    en: 'Mexico'
  }
}, {
  mask: '+60-##-###-####',
  test: /^60(\d{0,9})/g,
  valid: /^60(\d{9})$/,
  count: 2,
  code: '+60',
  country: 'MY',
  names: {
    ru: 'Малайзия',
    en: 'Malaysia'
  }
}, {
  mask: '+60-##-###-###',
  test: /^60(\d{0,8})/g,
  valid: /^60(\d{8})$/,
  count: 2,
  code: '+60',
  country: 'MY',
  names: {
    ru: 'Малайзия',
    en: 'Malaysia'
  }
}, {
  mask: '+60-#-###-###',
  test: /^60(\d{0,7})/g,
  valid: /^60(\d{7})$/,
  count: 2,
  code: '+60',
  country: 'MY',
  names: {
    ru: 'Малайзия',
    en: 'Malaysia'
  }
}, {
  mask: '+31-##-###-####',
  test: /^31(\d{0,9})/g,
  valid: /^31(\d{9})$/,
  count: 2,
  code: '+31',
  country: 'NL',
  names: {
    ru: 'Нидерланды',
    en: 'Netherlands'
  }
}, {
  mask: '+47(###)##-###',
  test: /^47(\d{0,8})/g,
  valid: /^47(\d{8})$/,
  count: 2,
  code: '+47',
  country: 'NO',
  names: {
    ru: 'Норвегия',
    en: 'Norway'
  }
}, {
  mask: '+64(###)###-###',
  test: /^64(\d{0,9})/g,
  valid: /^64(\d{9})$/,
  count: 2,
  code: '+64',
  country: 'NZ',
  names: {
    ru: 'Новая Зеландия',
    en: 'New Zealand'
  }
}, {
  mask: '+64-##-###-###',
  test: /^64(\d{0,8})/g,
  valid: /^64(\d{8})$/,
  count: 2,
  code: '+64',
  country: 'NZ',
  names: {
    ru: 'Новая Зеландия',
    en: 'New Zealand'
  }
}, {
  mask: '+64(###)###-####',
  test: /^64(\d{0,10})/g,
  valid: /^64(\d{10})$/,
  count: 2,
  code: '+64',
  country: 'NZ',
  names: {
    ru: 'Новая Зеландия',
    en: 'New Zealand'
  }
}, {
  mask: '+51(###)###-###',
  test: /^51(\d{0,9})/g,
  valid: /^51(\d{9})$/,
  count: 2,
  code: '+51',
  country: 'PE',
  names: {
    ru: 'Перу',
    en: 'Peru'
  }
}, {
  mask: '+63(###)###-####',
  test: /^63(\d{0,10})/g,
  valid: /^63(\d{10})$/,
  count: 2,
  code: '+63',
  country: 'PH',
  names: {
    ru: 'Филиппины',
    en: 'Philippines'
  }
}, {
  mask: '+92(###)###-####',
  test: /^92(\d{0,10})/g,
  valid: /^92(\d{10})$/,
  count: 2,
  code: '+92',
  country: 'PK',
  names: {
    ru: 'Пакистан',
    en: 'Pakistan'
  }
}, {
  mask: '+48(###)###-###',
  test: /^48(\d{0,9})/g,
  valid: /^48(\d{9})$/,
  count: 2,
  code: '+48',
  country: 'PL',
  names: {
    ru: 'Польша',
    en: 'Poland'
  }
}, {
  mask: '+40-##-###-####',
  test: /^40(\d{0,9})/g,
  valid: /^40(\d{9})$/,
  count: 2,
  code: '+40',
  country: 'RO',
  names: {
    ru: 'Румыния',
    en: 'Romania'
  }
}, {
  mask: '+46-##-###-####',
  test: /^46(\d{0,9})/g,
  valid: /^46(\d{9})$/,
  count: 2,
  code: '+46',
  country: 'SE',
  names: {
    ru: 'Швеция',
    en: 'Sweden'
  }
}, {
  mask: '+65-####-####',
  test: /^65(\d{0,8})/g,
  valid: /^65(\d{8})$/,
  count: 2,
  code: '+65',
  country: 'SG',
  names: {
    ru: 'Сингапур',
    en: 'Singapore'
  }
}, {
  mask: '+66-##-###-####',
  test: /^66(\d{0,9})/g,
  valid: /^66(\d{9})$/,
  count: 2,
  code: '+66',
  country: 'TH',
  names: {
    ru: 'Таиланд',
    en: 'Thailand'
  }
}, {
  mask: '+66-##-###-###',
  test: /^66(\d{0,8})/g,
  valid: /^66(\d{8})$/,
  count: 2,
  code: '+66',
  country: 'TH',
  names: {
    ru: 'Таиланд',
    en: 'Thailand'
  }
}, {
  mask: '+90(###)###-####',
  test: /^90(\d{0,10})/g,
  valid: /^90(\d{10})$/,
  count: 2,
  code: '+90',
  country: 'TR',
  names: {
    ru: 'Турция',
    en: 'Turkey'
  }
}, {
  mask: '+44-##-####-####',
  test: /^44(\d{0,10})/g,
  valid: /^44(\d{10})$/,
  count: 2,
  code: '+44',
  country: 'GB',
  names: {
    ru: 'Великобритания',
    en: 'Great Britain'
  }
}, {
  mask: '+58(###)###-####',
  test: /^58(\d{0,10})/g,
  valid: /^58(\d{10})$/,
  count: 2,
  code: '+58',
  country: 'VE',
  names: {
    ru: 'Венесуэла',
    en: 'Venezuela'
  }
}, {
  mask: '+84-##-####-###',
  test: /^84(\d{0,9})/g,
  valid: /^84(\d{9})$/,
  count: 2,
  code: '+84',
  country: 'VN',
  names: {
    ru: 'Вьетнам',
    en: 'Vietnam'
  }
}, {
  mask: '+84(###)####-###',
  test: /^84(\d{0,10})/g,
  valid: /^84(\d{10})$/,
  count: 2,
  code: '+84',
  country: 'VN',
  names: {
    ru: 'Вьетнам',
    en: 'Vietnam'
  }
}, {
  mask: '+27-##-###-####',
  test: /^27(\d{0,9})/g,
  valid: /^27(\d{9})$/,
  count: 2,
  code: '+27',
  country: 'ZA',
  names: {
    ru: 'Южно-Африканская Республика',
    en: 'South Africa'
  }
}, {
  mask: '+7(###)###-##-##',
  pretest: true,
  precode: '+7',
  test: /^(7([1234589])|8([134589]))(\d{0,9})/g,
  valid: /^(7([1234589])|8([134589]))(\d{9})$/,
  count: 1,
  code: '+7',
  country: 'RU',
  names: {
    ru: 'Россия',
    en: 'Russia'
  }
}, {
  areaCodes: _areaCodes.CanadaAreaCodes,
  mask: '+1(###)###-####',
  test: /^1(\d{0,10})/g,
  valid: /^1(\d{10})$/,
  count: 1,
  code: '+1',
  country: 'CA',
  names: {
    ru: 'Канада',
    en: 'Canada'
  }
}, {
  mask: '+1(###)###-####',
  test: /^1(\d{0,10})/g,
  valid: /^1(\d{10})$/,
  count: 1,
  code: '+1',
  country: 'US',
  names: {
    ru: 'США',
    en: 'USA'
  }
}];
exports.default = _default;